import { mapValues } from 'lodash';

export const stringifyFormValues = values =>
  mapValues(values, value => (value === null ? '' : value));
